import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SpesenService} from '../../spesen.service';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import {loadSpesenFailed, loadSpesenStart, loadSpesenSucceeded} from '../actions/getAllSpesen.actions';
import {deleteSpeseFailed, deleteSpeseStart, deleteSpeseSucceeded} from '../actions/spese-del.actions';
import {loadSpesenartenFailed, loadSpesenartenStart, loadSpesenartenSucceeded} from '../actions/spesenart.actions';
import {addSpesenFailed, addSpesenStart, addSpesenSucceeded} from '../actions/spesen-add.actions';
import {editSpesenFailed, editSpesenStart, editSpesenSucceeded} from '../actions/spesen-edit.actions';
import {deleteAllSpesenOfZeitStart, deleteAllSpesenOfZeitSucceeded} from '../actions/allSpesenOfZeit-del.actions';
import {getFilteredSeekDateStart} from '../actions/filter-seek-date.actions';
import {SpesenartService} from '../../spesenart.service';
import {addSpesenartFailed, addSpesenartStart, addSpesenartSucceeded} from '../actions/spesenart-add.actions';
import {deleteSpesenartFailed, deleteSpesenartStart, deleteSpesenartSucceeded} from '../actions/spesenart-del.actions';
import {editSpesenartFailed, editSpesenartStart, editSpesenartSucceeded} from '../actions/spesenart-edit.actions';
import {
  loadInactiveSpesenartenFailed,
  loadInactiveSpesenartenStart,
  loadInactiveSpesenartenSucceeded
} from '../actions/getInactiveSpesenart.action';
import {activateSpesenartFailed, activateSpesenartStart, activateSpesenartSucceeded} from '../actions/spesenart-activate.actions';
import {deactivateSpesenartFailed, deactivateSpesenartStart, deactivateSpesenartSucceeded} from '../actions/spesenart-deactivate.actions';

@Injectable()
export class SpesenartEffects {


  public loadSpesenarten$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSpesenartenStart),
      mergeMap(() =>
        this.spesenartService.getAllSpesenarten().pipe(
          map((response) => loadSpesenartenSucceeded({ item: response.data })),
          catchError((e) => of(loadSpesenartenFailed(e))),
        ),
      ),
    ),
  );

  public loadInactiveSpesenarten$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadInactiveSpesenartenStart),
      mergeMap(() =>
        this.spesenartService.getInactiveSpesenarten().pipe(
          tap(() => sessionStorage.setItem('spesenartIsAktiv', '0' )),
          map((response) => loadInactiveSpesenartenSucceeded({ item: response.data })),
          catchError((e) => of(loadInactiveSpesenartenFailed(e))),
        ),
      ),
    ),
  );

  public addSpesenart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addSpesenartStart),
      mergeMap((spesenart) =>
        this.spesenartService.addSpesenart(spesenart.item).pipe(
          mergeMap((response) => of(addSpesenartSucceeded({ item: response }), loadSpesenartenStart())),
          catchError((e) => of(addSpesenartFailed(e))),
        ),
      ),
    ),
  );

  public deleteSpesenart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteSpesenartStart),
      mergeMap((spesenart) =>
        this.spesenartService.deleteSpesenart(spesenart.item).pipe(
          mergeMap((response) => of(deleteSpesenartSucceeded({ item: response }), loadSpesenartenStart())),
          catchError((e) => of(deleteSpesenartFailed(e))),
        ),
      ),
    ),
  );

  public deactivateSpesenart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deactivateSpesenartStart),
      mergeMap((spesenart) =>
        this.spesenartService.deactivateSpesenart(spesenart.item).pipe(
          mergeMap((response) => of(deactivateSpesenartSucceeded({ item: response }), loadSpesenartenStart())),
          catchError((e) => of(deactivateSpesenartFailed(e))),
        ),
      ),
    ),
  );

  public activateSpesenart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(activateSpesenartStart),
      mergeMap((spesenart) =>
        this.spesenartService.activateSpesenart(spesenart.item).pipe(
          mergeMap((response) => of(activateSpesenartSucceeded({ item: response }), loadInactiveSpesenartenStart())),
          catchError((e) => of(activateSpesenartFailed(e))),
        ),
      ),
    ),
  );

  public editSpesenart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editSpesenartStart),
      mergeMap((spesenart) =>
        this.spesenartService.editSpesenart(spesenart.item).pipe(
          mergeMap((response) => of(editSpesenartSucceeded({ item: response }), loadSpesenartenStart())),
          catchError((e) => of(editSpesenartFailed(e))),
        ),
      ),
    ),
  );



  /**
   * Constructor of Zeit effects
   *
   * @param actions$ - The action observable
   * @param spesenartService
   */
  constructor(private actions$: Actions, private spesenartService: SpesenartService) {}
}
